export default [
    {
        path: '/network/ip-yonetimi',
        name: 'ip-yonetimi',
        meta: { resource: 'admin',key: 'ip-yonetimi' },
        component: () => import('../views/network/ip/list')
    },
    {
        path: '/network/router-yonetimi',
        name: 'router-yonetimi',
        meta: { resource: 'admin',key: 'router-yonetimi' },
        component: () => import('../views/network/router/list')
    },
    {
        path: '/network/verici-yonetimi',
        name: 'verici-yonetimi',
        meta: { resource: 'admin',key: 'verici-yonetimi' },
        component: () => import('../views/network/verici/list')
    }, 
]
  